import { render } from "./IconLinkPage.vue?vue&type=template&id=782fa6e2&ts=true"
import script from "./IconLinkPage.vue?vue&type=script&lang=ts"
export * from "./IconLinkPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__